module.exports = __webpack_public_path__ + "pdf/full.0d8dc9c.pdf";